import { Typography } from "@mui/material"
import type { FC } from "react"
import { twMerge } from "tailwind-merge"

import type { TransferTotals } from "../types"

import { formatNumber } from "@/utils/number"

interface CountBoxProps {
  label: string
  value: string
  className?: string
  "data-testid": string
}

const CountBox: FC<CountBoxProps> = ({ label, value, className, "data-testid": testId }) => {
  return (
    <div
      className={twMerge(
        "flex h-20 flex-col justify-center rounded-md border border-gray-400 bg-gray-100 px-6 py-1",
        className
      )}
      data-testid={testId}
    >
      <Typography variant='caption' component='span' className='text-primary'>
        {label}
      </Typography>
      <Typography variant='h6' component='span' className='font-bold text-gray-700'>
        {value}
      </Typography>
    </div>
  )
}

interface TransferTotalsSummaryProps {
  totals: TransferTotals
}

export const TransferTotalsSummary: FC<TransferTotalsSummaryProps> = ({ totals }) => {
  const { palletCount, quantity, uomName } = totals

  return (
    <div className='flex items-end justify-end gap-6' data-testid='transfer.totals-summary.totals-section'>
      <Typography variant='subtitle2' component='div' className='mb-5 font-bold text-gray-800'>
        Total
      </Typography>
      <div className='flex items-center gap-6'>
        <CountBox
          label='Pallets'
          value={String(palletCount)}
          className='min-w-[92px]'
          data-testid='transfer.totals-summary.total-pallets'
        />
        <CountBox
          label='Total UoM'
          value={uomName ? `${formatNumber(quantity, 0, 0)} ${uomName}` : formatNumber(quantity, 0, 0)}
          className='min-w-[152px]'
          data-testid='transfer.totals-summary.total-uom'
        />
      </div>
    </div>
  )
}
